(function () {
  const DESKTOP_QUERY = '(min-width: 750px)';

  function initComplementaryNav(container) {
    if (container.dataset.navInit === 'true') {
      return;
    }

    const inner = container.querySelector('.complementary-products--inner');
    const prevButton = container.querySelector('.scroll-nav-button.prev');
    const nextButton = container.querySelector('.scroll-nav-button.next');
    const nav = container.querySelector('.complementary-products--nav');

    if (!inner || !prevButton || !nextButton || !nav) {
      return;
    }

    container.dataset.navInit = 'true';

    function scroll(direction) {
      const card = inner.querySelector('.product-card-small');
      const gap = parseFloat(getComputedStyle(inner).columnGap || getComputedStyle(inner).gap) || 10;
      const scrollAmount = card ? card.offsetWidth + gap : inner.clientWidth * 0.75;
      const targetScroll =
        direction === 'left' ? inner.scrollLeft - scrollAmount : inner.scrollLeft + scrollAmount;

      inner.scrollTo({ left: targetScroll, behavior: 'smooth' });
    }

    function updateButtonVisibility() {
      const isDesktop = window.matchMedia(DESKTOP_QUERY).matches;
      const hasScroll = inner.scrollWidth > inner.clientWidth + 1;

      nav.style.display = isDesktop && hasScroll ? 'flex' : 'none';

      if (!isDesktop || !hasScroll) {
        return;
      }

      const isAtStart = inner.scrollLeft <= 1;
      const isAtEnd = inner.scrollLeft + inner.clientWidth >= inner.scrollWidth - 1;

      prevButton.style.opacity = isAtStart ? '0.35' : '1';
      nextButton.style.opacity = isAtEnd ? '0.35' : '1';
      prevButton.style.pointerEvents = isAtStart ? 'none' : 'auto';
      nextButton.style.pointerEvents = isAtEnd ? 'none' : 'auto';
    }

    prevButton.addEventListener('click', () => scroll('left'));
    nextButton.addEventListener('click', () => scroll('right'));
    inner.addEventListener('scroll', updateButtonVisibility, { passive: true });
    window.addEventListener('resize', updateButtonVisibility);

    updateButtonVisibility();
  }

  window.initComplementaryProductsNav = initComplementaryNav;

  function initAll(root) {
    (root || document)
      .querySelectorAll('.product-information .complementary-products')
      .forEach(initComplementaryNav);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('complementary-products:loaded', (event) => {
    if (event.detail && event.detail.element) {
      initComplementaryNav(event.detail.element);
    }
  });
})();
